import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import MainSection from './components/MainSection';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <MainSection />
    </div>
  );
}

export default App;
